import {required} from 'vuelidate/lib/validators'

export default {
  obscoreG: {
    required
  },
  obscoreP: {
    required
  },
  obscoreFT: {
    required
  },
  obscorePr: {
    required
  },
  obscoreAb: {
    required
  },
  obscoreLB: {
    required
  }
}
